import { NumberInput, type NumberInputHandlers } from '@mantine/core'
import { sendOutput, sendSignal } from '@shared/port-send-v1.0.0'
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import type { Props } from '../node/definition'

export default forwardRef((p: Props, ref) => {
	const { useSnapshot, proxy } = R.libs.valtio
	const { get, set } = R.libs.just

	const [initialSetted, setInitialSetted] = useState(false)
	const [value, setValue] = useState<string | number>('')
	const handlers = useRef<NumberInputHandlers>()

	// mode = item
	const item = useSnapshot(p.mode === 'item' && p.itemId ? R.items[p.itemId] : proxy())

	// mode = value
	useEffect(() => {
		if (p.mode === 'value' && (p.initialValue === 0 || p.initialValue) && !initialSetted) {
			setValue(p.initialValue === 0 ? p.initialValue : p.initialValue || '')
			setInitialSetted(true)
		}
		if (p.mode === 'item' && !initialSetted && get(item, p.itemField || '')) {
			setValue(get(item, p.itemField || ''))
			setInitialSetted(true)
		}
	}, [p.initialValue, p.mode, item])

	// outputs
	useEffect(() => {
		if (value !== '' && p.mode === 'item' && p.itemId && p.itemField) set(R.items, `${p.itemId}.${p.itemField}`, value)

		sendOutput(p.noodlNode, 'value', value === '' ? null : value)
		sendSignal(p.noodlNode, 'changed')
	}, [value])

	// sections
	const children: any = p.children

	const leftSection = Array.isArray(children)
		? children.filter((i) => i?.props.noodlNode.model?.type.split('.')[2] === 'NumberInputLeftSection')?.[0]
		: children?.props.noodlNode.model?.type.split('.')[2] === 'NumberInputLeftSection'
			? children
			: null

	const rightSection = Array.isArray(children)
		? children.filter((i) => i?.props.noodlNode.model?.type.split('.')[2] === 'NumberInputRightSection')?.[0]
		: children?.props.noodlNode.model?.type.split('.')[2] === 'NumberInputRightSection'
			? children
			: null

	useImperativeHandle(
		ref,
		() => ({
			reset() {
				if (p.mode === 'value') setValue(p.initialValue === 0 ? p.initialValue : p.initialValue || '')
				sendOutput(p.noodlNode, 'value', null)
				sendSignal(p.noodlNode, 'reseted')
			},
			increment() {
				handlers.current?.increment()
			},
			decrement() {
				handlers.current?.decrement()
			},
		}),
		[]
	)

	return (
		<NumberInput
			value={p.mode === 'value' ? value : get(item, p.itemField || '')}
			onChange={setValue}
			handlersRef={handlers}
			clampBehavior={p.clamp ? 'strict' : 'blur'}
			leftSection={leftSection}
			rightSection={rightSection}
			{...R.libs.just.omit(p, 'children')}
			{...p.customProps}
		/>
	)
})
